<svg
  [attr.width]="size"
  [attr.height]="size"
  fill="none"
  viewBox="0 0 24 24"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M9.5547 9.83205C9.8329 9.64658 10 9.33435 10 9V5C10 3.34315 8.65685 2 7 2H3C2.44772 2 2 2.44772 2 3C2 12.9411 11.0589 22 21 22C21.5523 22 22 21.5523 22 21V17C22 15.3431 20.6569 14 19 14H15C14.6656 14 14.3534 14.1671 14.1679 14.4453L12.2626 17.3033C10.1874 15.9615 8.36925 14.1892 6.97074 12.149L6.69668 11.7374L9.5547 9.83205ZM15.5352 16H19C19.5523 16 20 16.4477 20 17V19.9653C18.0628 19.8313 16.1721 19.3132 14.4087 18.4916L14.0041 18.2966L15.5352 16ZM15 2C15.5128 2 15.9355 2.38604 15.9933 2.88338L16 3V9C16 9.55228 15.5523 10 15 10C14.4872 10 14.0645 9.61396 14.0067 9.11662L14 9V3C14 2.44772 14.4477 2 15 2ZM19 2C19.5128 2 19.9355 2.38604 19.9933 2.88338L20 3V9C20 9.55228 19.5523 10 19 10C18.4872 10 18.0645 9.61396 18.0067 9.11662L18 9V3C18 2.44772 18.4477 2 19 2ZM7 4C7.55228 4 8 4.44772 8 5V8.46482L5.70338 9.9959C4.76882 8.11845 4.17903 6.08626 4.03467 4H7Z"
    fill="currentColor"
  />
</svg>
